import { Browser } from "@capacitor/browser";
import { AppLauncher } from "@capacitor/app-launcher";
import { Capacitor } from "@capacitor/core";

const GOOGLE_AUTHENTICATOR_ANDROID_PACKAGE =
  "com.google.android.apps.authenticator2";

export const isRunningInNativeApp = () => Capacitor.isNativePlatform();

export const openExternalUrl = async (url: string): Promise<boolean> => {
  if (isRunningInNativeApp()) {
    await Browser.open({ url });
    return true;
  }

  return window.open(url, "_blank", "noopener,noreferrer") !== null;
};

export const navigateCurrentWindow = (url: string): void => {
  window.location.assign(url);
};

export const openGoogleAuthenticator = async (
  provisioningUrl?: string,
): Promise<boolean> => {
  if (!isRunningInNativeApp()) return false;
  if (provisioningUrl && !/^otpauth:\/\/(totp|hotp)\//i.test(provisioningUrl)) {
    return false;
  }

  const url = provisioningUrl || GOOGLE_AUTHENTICATOR_ANDROID_PACKAGE;

  try {
    const { completed } = await AppLauncher.openUrl({ url });
    return completed;
  } catch {
    return false;
  }
};
